(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // ── UTM-gated announcement bars ────────────────────────────
  (function () {
    var bars = document.querySelectorAll('.announcement-bar[data-utm-value]');
    if (!bars.length) return;

    var params = new URLSearchParams(window.location.search);

    bars.forEach(function (bar) {
      var utmParam = bar.dataset.utmParam || 'utm_source';
      var utmValue = bar.dataset.utmValue;
      var storageKey = 'ann_utm_' + utmParam + '_' + utmValue;

      // Always show in the theme editor
      if (window.Shopify && window.Shopify.designMode) {
        bar.style.display = '';
        return;
      }

      // Persist a match so the bar survives page-to-page navigation
      if (params.get(utmParam) === utmValue) {
        try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
      }

      var matched = false;
      try { matched = sessionStorage.getItem(storageKey) === '1'; } catch (e) {}

      if (matched) bar.style.display = '';
    });
  })();

  document.addEventListener('DOMContentLoaded', function () {
    function isoToFlag(code) {
      return [...code.toUpperCase()].map(function (c) {
        return String.fromCodePoint(c.charCodeAt(0) + 0x1F1A5);
      }).join('');
    }

    document.querySelectorAll('.announcement-bar__flag').forEach(function (el) {
      var code = el.closest('[data-country-code]').getAttribute('data-country-code');
      if (code) el.textContent = isoToFlag(code);
    });

    var buttons = document.querySelectorAll('.announcement-bar [aria-controls]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.announcement-bar__selector')) {
        buttons.forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      buttons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-copy-url]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        navigator.clipboard.writeText(window.location.href).then(function () {
          var prev = btn.getAttribute('aria-label');
          btn.setAttribute('aria-label', 'Copied!');
          setTimeout(function () { btn.setAttribute('aria-label', prev); }, 2000);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    function initFeaturedCarousel() {
      var carousel = document.querySelector('[data-featured-carousel]');
      if (!carousel) return;
      var track = carousel.querySelector('[data-featured-track]');
      var slides = carousel.querySelectorAll('[data-slide]');
      var counter = carousel.querySelector('[data-feat-counter]');
      if (!track || slides.length < 2) return;

      var current = 0;
      var total = slides.length;
      var autoTimer;

      function goTo(idx) {
        current = (idx + total) % total;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        if (counter) counter.textContent = (current + 1) + ' / ' + total;
      }

      function startAuto() {
        autoTimer = setInterval(function () { goTo(current + 1); }, 5000);
      }

      function stopAuto() { clearInterval(autoTimer); }

      var prevBtn = carousel.querySelector('[data-feat-prev]');
      var nextBtn = carousel.querySelector('[data-feat-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); goTo(current - 1); startAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); goTo(current + 1); startAuto(); });

      // Swipe
      var startX = 0;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { stopAuto(); goTo(diff > 0 ? current + 1 : current - 1); startAuto(); }
      }, { passive: true });

      startAuto();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFeaturedCarousel);
    } else {
      initFeaturedCarousel();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    function initCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var panel = drawer.querySelector('.cart-drawer__panel');
    var moneyFormat = drawer.dataset.moneyFormat || '£{{amount}}';

    // ── Helpers ────────────────────────────────────────

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)));
    }

    function updateBadge(count) {
      document.querySelectorAll('.site-header__icon--cart').forEach(function (iconEl) {
        var badge = iconEl.querySelector('.site-header__cart-badge');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__cart-badge';
            badge.setAttribute('aria-hidden', 'true');
            iconEl.insertBefore(badge, iconEl.firstChild);
          }
          badge.textContent = count;
        } else {
          if (badge) badge.remove();
        }
      });
    }

    // ── Open / Close ───────────────────────────────────

    function openCart() {
      drawer.classList.add('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeCart() {
      drawer.classList.remove('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Expose for use by other section scripts (e.g. product.liquid)
    window.__cartDrawerOpen = openCart;
    window.__cartDrawerRefresh = refreshCart;

    // ── Refresh via Section Rendering API ──────────────

    async function refreshCart() {
      var noteWasOpen = false;
      var noteWrap = drawer.querySelector('[data-note-wrap]');
      if (noteWrap && !noteWrap.hidden) noteWasOpen = true;

      try {
        var res = await fetch('/?sections=cart-drawer', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        var data = await res.json();
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'] || '';
        var freshPanel = tmp.querySelector('.cart-drawer__panel');
        if (freshPanel && panel) {
          panel.innerHTML = freshPanel.innerHTML;
        }
        var freshDrawer = tmp.querySelector('[data-item-count]');
        if (freshDrawer) updateBadge(parseInt(freshDrawer.dataset.itemCount || '0', 10));
        if (noteWasOpen) {
          var newWrap = drawer.querySelector('[data-note-wrap]');
          if (newWrap) newWrap.hidden = false;
        }
        // Anything hooked onto the drawer's markup (loyalty points, for one)
        // is replaced wholesale above and needs to re-apply itself.
        document.dispatchEvent(new CustomEvent('cart:refreshed'));
      } catch (err) {
        console.error('[cart-drawer] refresh error', err);
      }
    }

    // ── Cart mutations ─────────────────────────────────

    async function changeQty(key, delta) {
      var item = drawer.querySelector('[data-item-key="' + key + '"]');
      var valEl = item && item.querySelector('.cart-drawer__qty-val');
      var current = valEl ? parseInt(valEl.textContent, 10) : 1;
      var newQty = Math.max(0, current + delta);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });
      await refreshCart();
    }

    async function removeItem(key) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await refreshCart();
    }

    // ── Note save (debounced) ──────────────────────────

    var noteTimer;
    function saveNote(note) {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ note: note })
        });
      }, 800);
    }

    // ── Event delegation ───────────────────────────────

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) {
        e.preventDefault();
        openCart();
        return;
      }
      if (e.target.closest('[data-cart-close]')) {
        closeCart();
        return;
      }
      var removeBtn = e.target.closest('[data-remove]');
      if (removeBtn) { removeItem(removeBtn.dataset.remove); return; }

      var decBtn = e.target.closest('[data-qty-dec]');
      if (decBtn) { changeQty(decBtn.dataset.qtyDec, -1); return; }

      var incBtn = e.target.closest('[data-qty-inc]');
      if (incBtn) { changeQty(incBtn.dataset.qtyInc, 1); return; }

      if (e.target.closest('[data-note-toggle]')) {
        var noteWrap = drawer.querySelector('[data-note-wrap]');
        if (noteWrap) {
          noteWrap.hidden = !noteWrap.hidden;
          if (!noteWrap.hidden) {
            var textarea = noteWrap.querySelector('[data-cart-note]');
            if (textarea) textarea.focus();
          }
        }
        return;
      }
    });

    document.addEventListener('input', function (e) {
      if (e.target.matches('[data-cart-note]')) saveNote(e.target.value);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('cart-drawer--open')) closeCart();
    });

    // Focus trap
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('cart-drawer--open') || e.key !== 'Tab') return;
      var focusable = Array.from(panel.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return !el.closest('[hidden]'); });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartDrawer);
    } else {
      initCartDrawer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    function initCartPage() {
      document.addEventListener('click', function (e) {
        var decBtn = e.target.closest('[data-page-qty-dec]');
        if (decBtn) {
          e.preventDefault();
          var key = decBtn.dataset.pageQtyDec;
          var valEl = document.querySelector('[data-page-qty-val="' + key + '"]');
          var current = valEl ? parseInt(valEl.textContent, 10) : 1;
          changePageQty(key, Math.max(0, current - 1));
          return;
        }
        var incBtn = e.target.closest('[data-page-qty-inc]');
        if (incBtn) {
          e.preventDefault();
          var key = incBtn.dataset.pageQtyInc;
          var valEl = document.querySelector('[data-page-qty-val="' + key + '"]');
          var current = valEl ? parseInt(valEl.textContent, 10) : 1;
          changePageQty(key, current + 1);
          return;
        }
        if (e.target.closest('[data-note-toggle]')) {
          var wrap = document.querySelector('[data-note-wrap]');
          if (wrap) wrap.hidden = !wrap.hidden;
          return;
        }
      });

      var noteTimer;
      document.addEventListener('input', function (e) {
        if (!e.target.matches('[data-cart-note]')) return;
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ note: e.target.value })
          });
        }, 800);
      });
    }

    function changePageQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () {
        window.location.reload();
      }).catch(function (err) {
        console.error('[cart-page] qty update failed', err);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartPage);
    } else {
      initCartPage();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initForms() {
      document.querySelectorAll('.collection-grid__form').forEach(function (form) {
        if (form._cartBound) return;
        form._cartBound = true;
        form.addEventListener('submit', async function (e) {
          e.preventDefault();
          if (form._adding) return;
          form._adding = true;
          var btn = form.querySelector('[type="submit"]');
          var originalHTML = btn ? btn.innerHTML : '';
          if (btn) btn.disabled = true;
          try {
            var res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
              body: new URLSearchParams(new FormData(form))
            });
            if (res.ok) {
              if (typeof window.__cartDrawerRefresh === 'function') {
                await window.__cartDrawerRefresh();
              }
              if (typeof window.__cartDrawerOpen === 'function') {
                window.__cartDrawerOpen();
              } else {
                window.location.href = '/cart';
              }
            } else {
              var err = await res.json().catch(function () { return {}; });
              console.error('[collection-grid] add to cart failed', err.description || err);
            }
          } catch (err) {
            console.error('[collection-grid] add to cart error', err);
          } finally {
            form._adding = false;
            if (btn) {
              btn.disabled = false;
              btn.innerHTML = originalHTML;
            }
          }
        });
      });
    }

    function init() {
      initForms();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.collection-grid__form').forEach(function (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (form._adding) return;
        form._adding = true;
        var btn = form.querySelector('[type="submit"]');
        var originalText = btn ? btn.innerHTML : '';
        if (btn) btn.disabled = true;
        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: new URLSearchParams(new FormData(form))
          });
          if (res.ok) {
            if (typeof window.__cartDrawerRefresh === 'function') {
              await window.__cartDrawerRefresh();
            }
            if (typeof window.__cartDrawerOpen === 'function') {
              window.__cartDrawerOpen();
            } else {
              window.location.href = '/cart';
            }
          } else {
            var err = await res.json().catch(function () { return {}; });
            console.error('[collection] add to cart failed', err.description || err);
          }
        } catch (err) {
          console.error('[collection] add to cart error', err);
        } finally {
          form._adding = false;
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = originalText;
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["credentials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.credentials').forEach(function (section) {
      var items  = Array.from(section.querySelectorAll('.credentials__item'));
      var slides = Array.from(section.querySelectorAll('.credentials__slide'));

      if (!items.length) return;

      function activate(index) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('credentials__slide--active', i === index);
        });
      }

      items.forEach(function (item, index) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          /* Close all other items */
          items.forEach(function (other, i) {
            if (i !== index && other.open) other.open = false;
          });
          activate(index);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.feature-cards');
    sections.forEach(function (section) {
      var track = section.querySelector('[data-fc-track]');
      var dots  = section.querySelectorAll('[data-fc-dots] .feature-cards__dot');
      if (!track || !dots.length) return;

      /* Update active dot based on which card is snapped */
      function updateDots() {
        var cards = track.querySelectorAll('.feature-cards__card');
        var closest = 0, minDist = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var dist = Math.abs(cards[i].offsetLeft - track.scrollLeft);
          if (dist < minDist) { minDist = dist; closest = i; }
        }
        dots.forEach(function (dot, i) {
          dot.classList.toggle('feature-cards__dot--active', i === closest);
        });
      }

      track.addEventListener('scroll', updateDots, { passive: true });

      /* Dot click → scroll to card */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx  = parseInt(dot.dataset.index, 10);
          var card = track.querySelectorAll('.feature-cards__card')[idx];
          if (card) track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('mobile-nav-drawer');
    var hamburger = document.querySelector('.site-header__hamburger');
    if (!drawer || !hamburger) return;

    var closeBtn = drawer.querySelector('.mobile-nav__close');
    var backdrop = drawer.querySelector('.mobile-nav__backdrop');

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('button, a');
      if (first) first.focus();
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    hamburger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });

    function isoToFlag(code) {
      return [...code.toUpperCase()].map(function (c) {
        return String.fromCodePoint(c.charCodeAt(0) + 0x1F1A5);
      }).join('');
    }

    drawer.querySelectorAll('.country-flag').forEach(function (el) {
      var parent = el.closest('[data-country-code]');
      if (parent) el.textContent = isoToFlag(parent.getAttribute('data-country-code'));
    });

    var selectorBtn = drawer.querySelector('.mobile-nav__selector-button');
    if (selectorBtn) {
      selectorBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = selectorBtn.getAttribute('aria-expanded') === 'true';
        selectorBtn.setAttribute('aria-expanded', String(!isOpen));
      });
      drawer.addEventListener('click', function (e) {
        if (!e.target.closest('.mobile-nav__selector')) {
          selectorBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  /* ── Bee swarm animations ── */
  (function () {
    var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function parseHex(hex) {
      hex = hex.replace('#', '');
      if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
      return [parseInt(hex.slice(0,2),16), parseInt(hex.slice(2,4),16), parseInt(hex.slice(4,6),16)];
    }

    function BeeSwarm(canvas) {
      var dpr = window.devicePixelRatio || 1;
      var W = 64, H = 64;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      var ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      this.ctx = ctx; this.W = W; this.H = H;
      this.cx = W/2; this.cy = H/2;
      this.rgb = parseHex(canvas.dataset.beeColor || '#e8b313');
      this.elapsed = 0; this.lastTS = null; this.rafId = null; this.active = false;
      var beeIndex = parseInt(canvas.dataset.beeIndex, 10) || 0;
      var beeTotal = Math.max(parseInt(canvas.dataset.beeTotal, 10) || 1, 1);
      var beeMax = parseInt(canvas.dataset.beeMax, 10) || 100;
      var count = Math.max(3, Math.min(100, Math.round((beeIndex+1)/beeTotal*beeMax)));
      this.bees = [];
      for (var i = 0; i < count; i++) {
        this.bees.push({
          a: (i/count)*Math.PI*2, baseR: 8+(i%8)*2.5,
          dir: i%2===0?1:-1, speed: 0.35+0.10*(i%5),
          rPhase: Math.random()*Math.PI*2, rFreq: 0.6+Math.random()*0.7,
          rAmp: 2+Math.random()*3.5, sz: 2+Math.random()*1.6,
          al: 0.5+Math.random()*0.45, exciteT: 0,
          exciteNext: 2.5+Math.random()*5, exciteAge: Math.random()*4,
        });
      }
      this._observe(canvas);
    }

    BeeSwarm.prototype._observe = function (canvas) {
      var self = this;
      if (!window.IntersectionObserver) { self.active = true; self._start(); return; }
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { self.active = true; self._start(); }
        else { self.active = false; if (self.rafId) { cancelAnimationFrame(self.rafId); self.rafId = null; } }
      }, { threshold: 0.1 }).observe(canvas);
    };

    BeeSwarm.prototype._start = function () {
      if (this.rafId) return;
      var self = this; self.lastTS = null;
      function tick(ts) {
        if (!self.active) { self.rafId = null; return; }
        if (self.lastTS === null) self.lastTS = ts;
        var dt = Math.min((ts - self.lastTS)/1000, 0.05);
        self.lastTS = ts; self.elapsed += dt;
        self._draw(dt);
        self.rafId = requestAnimationFrame(tick);
      }
      self.rafId = requestAnimationFrame(tick);
    };

    BeeSwarm.prototype._draw = function (dt) {
      var ctx = this.ctx, W = this.W, H = this.H, cx = this.cx, cy = this.cy;
      var elapsed = this.elapsed, rgb = this.rgb;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < this.bees.length; i++) {
        var b = this.bees[i];
        if (!REDUCED_MOTION) {
          b.exciteAge += dt;
          if (b.exciteAge >= b.exciteNext) { b.exciteT = 0.55; b.exciteAge = 0; b.exciteNext = 2.5+Math.random()*5; }
          if (b.exciteT > 0) b.exciteT = Math.max(0, b.exciteT - dt);
          var speedBoost = b.exciteT > 0 ? (1+(b.exciteT/0.55)*1.3) : 1;
          b.a += b.dir * b.speed * dt * speedBoost;
        }
        var em = b.exciteT > 0 ? (1+(b.exciteT/0.55)*0.45) : 1;
        var r = (b.baseR + Math.sin(elapsed*b.rFreq+b.rPhase)*b.rAmp)*em;
        var sz = b.sz * (b.exciteT > 0 ? 1.2 : 1);
        ctx.beginPath();
        ctx.arc(cx+r*Math.cos(b.a), cy+r*Math.sin(b.a)*0.72, sz, 0, Math.PI*2);
        ctx.fillStyle = 'rgba('+rgb[0]+','+rgb[1]+','+rgb[2]+','+b.al+')';
        ctx.fill();
      }
    };

    function initBees() {
      document.querySelectorAll('.bee-swarm:not([data-bees-init])').forEach(function (c) {
        c.dataset.beesInit = '1';
        new BeeSwarm(c);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBees);
    else initBees();
  })();

  /* ── Mega dropdown hover ── */
  (function () {
    function initMega() {
      document.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
        var panel = document.getElementById(trigger.dataset.megaTrigger);
        if (!panel) return;
        var hideTimer;
        function show() {
          clearTimeout(hideTimer);
          panel.setAttribute('aria-hidden', 'false');
        }
        function scheduleHide() {
          hideTimer = setTimeout(function () {
            panel.setAttribute('aria-hidden', 'true');
          }, 120);
        }
        trigger.addEventListener('mouseenter', show);
        trigger.addEventListener('mouseleave', scheduleHide);
        panel.addEventListener('mouseenter', show);
        panel.addEventListener('mouseleave', scheduleHide);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMega);
    else initMega();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    function initNewsletterPopup() {
      var popup = document.getElementById('newsletter-popup');
      if (!popup) return;

      // Don't run on Shopify's bot-protection challenge page
      if (window.location.pathname === '/challenge') return;

      var triggerViews = parseInt(popup.dataset.triggerViews, 10) || 2;
      var cookieName = 'nm_popup_dismissed';
      var cookieDays = 30;

      // Below this width the popup is a non-blocking bottom toast, so it must
      // not behave as a modal: no scroll lock, no focus trap, no stolen focus.
      var toastQuery = window.matchMedia('(max-width: 749px)');
      function isToast() { return toastQuery.matches; }

      function getCookie(name) {
        var match = document.cookie.match(
          new RegExp('(?:^|; )' + name.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1') + '=([^;]*)')
        );
        return match ? match[1] : null;
      }

      function setCookie(name, value, days) {
        var expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = name + '=' + value + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
      }

      function applyMode() {
        var toast = isToast();
        popup.setAttribute('aria-modal', toast ? 'false' : 'true');
        document.body.style.overflow = toast ? '' : 'hidden';
      }

      function openModal() {
        popup.classList.add('newsletter-popup--open');
        popup.setAttribute('aria-hidden', 'false');
        applyMode();
        // A toast is non-modal — pulling focus into it would yank the keyboard
        // open mid-scroll, which is the behaviour we're trying to avoid.
        if (!isToast()) {
          var emailInput = popup.querySelector('[data-popup-email]');
          if (emailInput) setTimeout(function () { emailInput.focus(); }, 50);
        }
      }

      function closeModal() {
        popup.classList.remove('newsletter-popup--open');
        popup.setAttribute('aria-hidden', 'true');
        popup.setAttribute('aria-modal', 'true');
        document.body.style.overflow = '';
        setCookie(cookieName, '1', cookieDays);
      }

      // Rotating the device shouldn't leave the page scroll-locked, or leave a
      // desktop-sized modal without its lock.
      var onModeChange = function () {
        if (popup.classList.contains('newsletter-popup--open')) applyMode();
      };
      if (toastQuery.addEventListener) {
        toastQuery.addEventListener('change', onModeChange);
      } else if (toastQuery.addListener) {
        toastQuery.addListener(onModeChange);
      }

      function showSuccess() {
        var formState = popup.querySelector('[data-popup-form-state]');
        var successState = popup.querySelector('[data-popup-success-state]');
        if (formState) formState.hidden = true;
        if (successState) successState.hidden = false;
        setCookie(cookieName, '1', cookieDays);
      }

      // Event listeners registered before any early return
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-popup-close]')) {
          closeModal();
          return;
        }
        if (e.target.matches('[data-popup-overlay]')) {
          closeModal();
          return;
        }
        var copyBtn = e.target.closest('[data-copy-code]');
        if (!copyBtn) return;
        var code = copyBtn.dataset.copyCode;
        var originalText = copyBtn.textContent;
        try {
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.textContent = 'Copied!';
            setTimeout(function () { copyBtn.textContent = originalText; }, 2000);
          });
        } catch (err) {
          copyBtn.textContent = 'Copied!';
          setTimeout(function () { copyBtn.textContent = originalText; }, 2000);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('newsletter-popup--open')) {
          closeModal();
        }
      });

      document.addEventListener('keydown', function (e) {
        // No focus trap in toast mode — the rest of the page is still usable
        if (isToast()) return;
        if (!popup.classList.contains('newsletter-popup--open') || e.key !== 'Tab') return;
        var panel = popup.querySelector('.newsletter-popup__panel');
        var focusable = Array.from(panel.querySelectorAll(
          'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) { return !el.closest('[hidden]'); });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      // Shopify server-side signal: form was just processed (after /challenge or normal submit)
      if (document.getElementById('newsletter-popup-success-signal')) {
        history.replaceState(null, '', window.location.pathname);
        setTimeout(function () { openModal(); showSuccess(); }, 300);
        return;
      }

      // Normal trigger logic
      var inDesignMode = window.Shopify && window.Shopify.designMode;
      var views = 1;
      try {
        views = parseInt(localStorage.getItem('nm_popup_views') || '0', 10) + 1;
        localStorage.setItem('nm_popup_views', String(views));
      } catch (e) {
        views = triggerViews;
      }

      if (inDesignMode) {
        setTimeout(openModal, 400);
      } else if (!getCookie(cookieName) && views >= triggerViews) {
        setTimeout(openModal, 600);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNewsletterPopup);
    } else {
      initNewsletterPopup();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-id]');
    if (!root) return;

    // ── Carousel ──────────────────────────────────────
    const carousel = root.querySelector('[data-product-carousel]');
    const track = carousel ? carousel.querySelector('[data-carousel-track]') : null;
    const slides = track ? track.querySelectorAll('[data-slide]') : [];
    const thumbsRoot = root.querySelector('[data-product-thumbs]');
    const thumbBtns = thumbsRoot ? thumbsRoot.querySelectorAll('[data-thumb]') : [];
    let current = 0;

    function goTo(index) {
      if (!carousel || !track) return;
      current = Math.max(0, Math.min(index, slides.length - 1));
      track.style.transform = 'translateX(-' + (current * carousel.offsetWidth) + 'px)';
      thumbBtns.forEach(function (btn) {
        btn.classList.toggle('product__thumb--active', parseInt(btn.dataset.thumb) === current);
      });
    }

    if (carousel) {
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { goTo(parseInt(btn.dataset.thumb)); });
      });

      // Slide offsets are pixel-based, so a resize/orientation change desyncs them
      window.addEventListener('resize', function () {
        track.style.transition = 'none';
        goTo(current);
        void track.offsetHeight;
        track.style.transition = '';
      });

      // A ?variant= link preselects a size server-side; start on that size's
      // image, as a click would, without animating from the first slide.
      var preselected = root.querySelector('.product__variant-btn--active[data-variant-image-id]');
      var preselectedId = preselected && preselected.dataset.variantImageId;
      if (preselectedId) {
        var startSlide = track.querySelector('[data-image-id="' + preselectedId + '"]');
        if (startSlide && parseInt(startSlide.dataset.slide) > 0) {
          track.style.transition = 'none';
          goTo(parseInt(startSlide.dataset.slide));
          void track.offsetHeight;
          track.style.transition = '';
        }
      }

      // ── Drag / swipe ────────────────────────────────
      if (slides.length > 1) {
        carousel.classList.add('product__carousel--draggable');

        let pointerId = null;
        let startX = 0;
        let startY = 0;
        let deltaX = 0;
        let locked = false;       // committed to a horizontal drag
        let suppressClick = false;

        function endDrag(dx) {
          if (pointerId === null) return;
          if (carousel.hasPointerCapture(pointerId)) carousel.releasePointerCapture(pointerId);
          pointerId = null;
          carousel.classList.remove('product__carousel--dragging');

          const threshold = Math.min(80, carousel.offsetWidth * 0.15);
          if (locked && Math.abs(dx) > threshold) {
            goTo(dx < 0 ? current + 1 : current - 1);
          } else {
            goTo(current);
          }

          suppressClick = locked;
          locked = false;
        }

        carousel.addEventListener('pointerdown', function (e) {
          if (pointerId !== null) return;                       // ignore a second finger
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.target.closest('[data-carousel-prev], [data-carousel-next]')) return;

          pointerId = e.pointerId;
          startX = e.clientX;
          startY = e.clientY;
          deltaX = 0;
          locked = false;
          suppressClick = false;
          carousel.classList.add('product__carousel--dragging');
        });

        carousel.addEventListener('pointermove', function (e) {
          if (e.pointerId !== pointerId) return;

          const dx = e.clientX - startX;
          const dy = e.clientY - startY;

          if (!locked) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;   // below the slop threshold
            if (Math.abs(dy) > Math.abs(dx)) { endDrag(0); return; }  // it's a vertical scroll
            locked = true;
            carousel.setPointerCapture(pointerId);
          }

          // Rubber-band when dragging past the first or last slide
          const atEdge = (current === 0 && dx > 0) || (current === slides.length - 1 && dx < 0);
          deltaX = atEdge ? dx * 0.3 : dx;
          track.style.transform = 'translateX(' + (deltaX - current * carousel.offsetWidth) + 'px)';
        });

        window.addEventListener('pointerup', function (e) {
          if (e.pointerId === pointerId) endDrag(deltaX);
        });

        window.addEventListener('pointercancel', function (e) {
          if (e.pointerId === pointerId) endDrag(0);
        });

        // Stop the native image ghost-drag, and swallow the click that ends a drag
        carousel.addEventListener('dragstart', function (e) { e.preventDefault(); });
        carousel.addEventListener('click', function (e) {
          if (!suppressClick) return;
          suppressClick = false;
          e.preventDefault();
          e.stopPropagation();
        }, true);
      }
    }

    // ── Variant picker ────────────────────────────────
    const variantInput = root.querySelector('[data-variant-id]');
    const sellingPlanInput = root.querySelector('[data-selling-plan]');
    const addBtn = root.querySelector('[data-add-btn]');
    const subscribeBtn = root.querySelector('[data-subscribe-btn]');
    const subscribeLabelPrefix = (subscribeBtn && subscribeBtn.dataset.labelPrefix) || 'Join the club for';
    const onetimePriceEl = root.querySelector('[data-onetime-price]');
    const subPriceEl = root.querySelector('[data-sub-price]');
    const subCompareEl = root.querySelector('[data-sub-compare]');

    const variantBtns = root.querySelectorAll('[data-variant-id][data-variant-price]');
    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        variantBtns.forEach(function (b) { b.classList.remove('product__variant-btn--active'); });
        btn.classList.add('product__variant-btn--active');

        const vid = btn.dataset.variantId;
        const price = parseInt(btn.dataset.variantPrice);
        const available = btn.dataset.variantAvailable === 'true';
        // One-time price after any variant promotion; the Club price stays on the full price
        const promoPct = parseInt(btn.dataset.variantPromo) || 0;
        const effectivePrice = price - Math.floor(price * promoPct / 100);

        if (variantInput) variantInput.value = vid;

        const promoLine = root.querySelector('[data-onetime-promo]');
        const promoBadge = root.querySelector('[data-onetime-promo-badge]');
        const promoNote = root.querySelector('[data-onetime-promo-note]');
        if (promoLine) {
          promoLine.hidden = promoPct <= 0;
          const now = promoLine.querySelector('[data-onetime-promo-now]');
          const was = promoLine.querySelector('[data-onetime-promo-was]');
          if (now) now.textContent = formatMoney(effectivePrice);
          if (was) was.textContent = formatMoney(price);
        }
        if (promoBadge) {
          promoBadge.hidden = promoPct <= 0;
          promoBadge.textContent = promoBadge.dataset.label.replace('[pct]', promoPct);
        }
        if (promoNote) {
          promoNote.hidden = promoPct <= 0;
          const stock = parseInt(btn.dataset.variantStock);
          const threshold = parseInt(promoNote.dataset.countThreshold) || 0;
          const useCount = stock > 0 && stock <= threshold && promoNote.dataset.labelCount;
          promoNote.textContent = useCount
            ? promoNote.dataset.labelCount.replace('[pct]', promoPct).replace('[count]', stock)
            : promoNote.dataset.label.replace('[pct]', promoPct);
        }

        // Jump carousel to variant's featured image
        const imageId = btn.dataset.variantImageId;
        if (imageId) {
          const slide = track ? track.querySelector('[data-image-id="' + imageId + '"]') : null;
          if (slide) goTo(parseInt(slide.dataset.slide));
        }

        // Update one-time button: label, struck full price, price to pay
        if (addBtn) {
          const addLabel = addBtn.querySelector('[data-add-label]');
          const addWas = addBtn.querySelector('[data-add-was]');
          const addPrice = addBtn.querySelector('[data-add-price]');
          if (available) {
            if (addLabel) {
              addLabel.textContent = addBtn.dataset.label || 'Add to cart';
              addLabel.classList.add('product__add-btn-label');
            }
            if (addWas) { addWas.textContent = formatMoney(price); addWas.hidden = promoPct <= 0; }
            if (addPrice) { addPrice.textContent = formatMoney(effectivePrice); addPrice.hidden = false; }
            addBtn.disabled = false;
          } else {
            if (addLabel) {
              addLabel.textContent = addBtn.dataset.labelSoldOut || 'Sold out';
              addLabel.classList.remove('product__add-btn-label');
            }
            if (addWas) addWas.hidden = true;
            if (addPrice) addPrice.hidden = true;
            addBtn.disabled = true;
          }
        }

        // Update per-serving prices
        const servings = parseInt(btn.dataset.variantServings) || 0;
        if (onetimePriceEl) {
          if (servings > 0) {
            const perServing = Math.round(effectivePrice / servings);
            const fullPerServing = Math.round(price / servings);
            onetimePriceEl.innerHTML = (promoPct > 0 ? '<s data-onetime-serving-was>' + formatMoney(fullPerServing) + '</s> ' : '')
              + '<span data-onetime-serving-text>' + formatMoney(perServing) + ' per serving</span>';
          } else {
            onetimePriceEl.textContent = '';
          }
        }

        const activeOption = root.querySelector('.product__option--subscribe.product__option--active');
        const subOption = activeOption || root.querySelector('.product__option--subscribe');
        if (subscribeBtn && subOption) {
          const pct = parseInt(subOption.dataset.discountPct) || 0;
          const discountAmount = Math.round(price * pct / 100);
          const subPrice = price - discountAmount;
          subscribeBtn.textContent = subscribeLabelPrefix + ' ' + formatMoney(subPrice);
        }

        if (subPriceEl) {
          const subOpt = activeOption || root.querySelector('.product__option--subscribe');
          if (subOpt && servings > 0) {
            const pct = parseInt(subOpt.dataset.discountPct) || 0;
            const discountAmount = Math.round(price * pct / 100);
            const subPrice = price - discountAmount;
            const subPerServing = Math.round(subPrice / servings);
            subPriceEl.textContent = formatMoney(subPerServing) + ' per serving';

            if (subCompareEl) {
              const onetimePerServing = Math.round(effectivePrice / servings);
              if (onetimePerServing > subPerServing) {
                subCompareEl.innerHTML = '(<s>' + formatMoney(onetimePerServing) + '</s>)';
                subCompareEl.hidden = false;
              } else {
                subCompareEl.hidden = true;
              }
            }
          } else {
            subPriceEl.textContent = '';
            if (subCompareEl) subCompareEl.hidden = true;
          }
        }
      });
    });

    // ── Purchase option toggle ────────────────────────
    // Driven by each card's own submit button, not the card itself, so the copy
    // inside the cards stays selectable.
    const options = root.querySelectorAll('[data-purchase-option]');
    function activateOption(type, planId) {
      options.forEach(function (o) {
        o.classList.toggle('product__option--active', o.dataset.purchaseOption === type);
      });
      if (sellingPlanInput) sellingPlanInput.value = planId || '';
    }

    // ── Delivery frequency (multiple intervals) ──────
    const planRadios = root.querySelectorAll('[data-plan-radio]');

    function selectedPlanId() {
      const checked = root.querySelector('[data-plan-radio]:checked');
      if (checked) return checked.value;
      const subOpt = root.querySelector('[data-purchase-option="subscribe"]');
      return subOpt ? subOpt.dataset.sellingPlanId || '' : '';
    }

    planRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (sellingPlanInput) sellingPlanInput.value = radio.value;
      });
    });

    // ── Quantity widget ───────────────────────────────
    const qtyInput = root.querySelector('[data-qty-input]');
    const qtyDisplay = root.querySelector('[data-qty-display]');
    const decBtn = root.querySelector('[data-qty-dec]');
    const incBtn = root.querySelector('[data-qty-inc]');

    function updateQty(delta) {
      if (!qtyInput) return;
      const next = Math.max(1, parseInt(qtyInput.value) + delta);
      qtyInput.value = next;
      if (qtyDisplay) qtyDisplay.textContent = next;
    }

    if (decBtn) decBtn.addEventListener('click', function () { updateQty(-1); });
    if (incBtn) incBtn.addEventListener('click', function () { updateQty(1); });

    // ── Strength links ────────────────────────────────
    // Switching strength is a page load, so warm it on hover/touch. Doing it on
    // intent rather than upfront keeps the cost off visitors who never switch.
    const strengthLinks = root.querySelectorAll('[data-strength-link]');
    const saveData = navigator.connection && navigator.connection.saveData;
    if (strengthLinks.length && !saveData) {
      const warmed = {};
      const warm = function (event) {
        const href = event.currentTarget.href;
        if (!href || warmed[href]) return;
        warmed[href] = true;
        const hint = document.createElement('link');
        hint.rel = 'prefetch';
        hint.href = href;
        document.head.appendChild(hint);
      };
      strengthLinks.forEach(function (link) {
        link.addEventListener('pointerenter', warm, { once: true });
        link.addEventListener('touchstart', warm, { once: true, passive: true });
      });
    }

    // ── Buy-box review quote ──────────────────────────
    // Latest short 5-star reviews for this product, read from the same public
    // Reviews.io timeline the carousel widget uses (no API key).
    const reviewBox = root.querySelector('[data-buybox-review]');
    // Without a SKU list the API answers store-wide, which would show another
    // product's review here, so skip entirely rather than fall back to that.
    const reviewSku = reviewBox ? (reviewBox.dataset.reviewSku || '') : '';
    if (reviewBox && window.fetch && reviewSku) {
      // Length is scored against this band; nothing is excluded for being outside it
      const idealMax = parseInt(reviewBox.dataset.reviewIdealLength) || 180;
      const idealMin = Math.round(idealMax * 0.45);
      const ceilingLen = Math.round(idealMax * 1.6);
      const maxReviews = parseInt(reviewBox.dataset.reviewCount) || 1;
      const verifiedLabel = reviewBox.dataset.reviewVerified || 'Verified customer';
      const dotLabel = reviewBox.dataset.reviewDotLabel || 'Show review [n]';
      // Keyed on everything that decides the result, so a changed query can never
      // be answered from a stale entry. Bump the version to discard old caches.
      const cacheKey = 'hm:buybox-reviews:v3:' + reviewSku + ':' + idealMax + ':' + maxReviews;
      const cacheTtl = 30 * 60 * 1000;

      // Words suggesting the review is about the honey itself…
      const SPECIFIC = /(flavou?r|tast(e|y|ed|ing)|textur|creamy|smooth|thick|rich|delicious|m[āa]nuka|mgo|spoon|tea|toast|yog?h?urt|quality|immune|energy|throat)/gi;
      // …and words suggesting it's about the parcel instead
      const LOGISTICS = /(deliver|packag|postage|shipping|arrived|dispatch)/i;

      // Long reviews lose on score rather than being excluded, so this only bites
      // when a product has nothing shorter. Cut on a word boundary.
      function truncate(text) {
        if (text.length <= ceilingLen) return text;
        const cut = text.slice(0, ceilingLen);
        const space = cut.lastIndexOf(' ');
        return cut.slice(0, space > 0 ? space : ceilingLen).replace(/[\s,;:.!?-]+$/, '') + '…';
      }

      // Ranks how quotable a review is beside the button. Every term is bounded so
      // no single signal decides it, and length is a preference, not a filter —
      // a product whose only reviews are long or terse still gets one.
      function score(review, recency) {
        const text = review.text;
        const len = text.length;
        let s = 0;

        if (len < idealMin) s += 3 * (len / idealMin);
        else if (len <= idealMax) s += 3;
        else s += 3 * Math.max(0, 1 - (len - idealMax) / idealMax);

        // Reads as a finished thought
        if (/[.!?]$/.test(text)) s += 1;
        if (/^[A-Z]/.test(text)) s += 0.5;

        // Says something specific rather than just "great product"
        const specifics = (text.match(SPECIFIC) || []).length;
        s += Math.min(specifics, 4) * 0.5;

        // A review about the parcel isn't much use next to Add to cart
        if (!specifics && LOGISTICS.test(text)) s -= 2;

        if (review.named) s += 1;
        if (review.helpful > 0) s += 0.5;

        // Shouting and mashed punctuation read badly as a pull quote
        const letters = text.replace(/[^A-Za-z]/g, '');
        if (letters.length > 8 && letters === letters.toUpperCase()) s -= 2;
        if (/(!{2,}|\?{2,})/.test(text)) s -= 0.5;

        // Recency breaks ties without overriding quality
        return s + recency * 0.4;
      }

      function pickReviews(entries) {
        const seen = {};
        const candidates = (entries || [])
          .map(function (entry) { return entry && entry._source; })
          .filter(function (src) {
            if (!src || src.rating !== 5) return false;
            const body = (src.comments || '').trim();
            if (!body) return false;
            const key = body.toLowerCase();
            if (seen[key]) return false;
            seen[key] = true;
            return true;
          })
          .map(function (src) {
            const name = (src.author || '').trim();
            const named = !!name && !/^anonymous$/i.test(name);
            return {
              // Some reviewers wrap their own text in quotes; we add our own.
              text: (src.comments || '')
                .replace(/^[\s"“”]+/, '')
                .replace(/[\s"“”]+$/, ''),
              named: named,
              author: named ? name + ', ' + verifiedLabel : verifiedLabel,
              helpful: parseInt(src.helpful) || 0,
              date: src.date_created || ''
            };
          });

        // Newest scores 1, oldest 0
        const ordered = candidates.map(function (r) { return r.date; }).sort();
        candidates.forEach(function (r) {
          const recency = ordered.length > 1 ? ordered.indexOf(r.date) / (ordered.length - 1) : 1;
          r.score = score(r, recency);
        });

        return candidates
          .sort(function (a, b) { return b.score - a.score || b.date.localeCompare(a.date); })
          .slice(0, maxReviews)
          .map(function (r) { return { text: truncate(r.text), author: r.author }; });
      }

      function render(reviews) {
        if (!reviews.length) return;

        const slides = document.createElement('div');
        slides.className = 'product__review-slides';
        const authors = document.createElement('div');
        authors.className = 'product__review-authors';

        reviews.forEach(function (review, i) {
          const slide = document.createElement('blockquote');
          slide.className = 'product__review-slide' + (i === 0 ? ' product__review-slide--active' : '');
          if (i !== 0) slide.setAttribute('aria-hidden', 'true');
          const text = document.createElement('p');
          text.className = 'product__review-text';
          text.textContent = '“' + review.text + '”';
          slide.appendChild(text);
          slides.appendChild(slide);

          // Attribution sits outside the quote so it stays level with the dots
          const author = document.createElement('cite');
          author.className = 'product__review-author' + (i === 0 ? ' product__review-author--active' : '');
          author.textContent = '— ' + review.author;
          if (i !== 0) author.setAttribute('aria-hidden', 'true');
          authors.appendChild(author);
        });

        const meta = document.createElement('div');
        meta.className = 'product__review-meta';
        meta.appendChild(authors);
        reviewBox.appendChild(slides);
        reviewBox.appendChild(meta);

        const slideEls = slides.children;
        const authorEls = authors.children;
        const dotEls = [];
        let index = 0;
        let timer = null;

        function stop() {
          if (timer) { clearInterval(timer); timer = null; }
        }

        function show(next) {
          index = (next + slideEls.length) % slideEls.length;
          for (let i = 0; i < slideEls.length; i++) {
            const active = i === index;
            slideEls[i].classList.toggle('product__review-slide--active', active);
            authorEls[i].classList.toggle('product__review-author--active', active);
            [slideEls[i], authorEls[i]].forEach(function (el) {
              if (active) el.removeAttribute('aria-hidden');
              else el.setAttribute('aria-hidden', 'true');
            });
            if (dotEls[i]) {
              dotEls[i].classList.toggle('product__review-dot--active', active);
              dotEls[i].setAttribute('aria-pressed', active ? 'true' : 'false');
            }
          }
        }

        if (reviews.length > 1) {
          const dots = document.createElement('div');
          dots.className = 'product__review-dots';
          reviews.forEach(function (review, i) {
            const dot = document.createElement('button');
            // Inside the product form, so it must never act as a submit button
            dot.type = 'button';
            dot.className = 'product__review-dot' + (i === 0 ? ' product__review-dot--active' : '');
            dot.setAttribute('aria-label', dotLabel.replace('[n]', i + 1));
            dot.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
            dot.addEventListener('click', function () { stop(); show(i); });
            dots.appendChild(dot);
            dotEls.push(dot);
          });
          meta.appendChild(dots);

          const reduceMotion = window.matchMedia
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!reduceMotion) {
            timer = setInterval(function () { show(index + 1); }, 6000);
            reviewBox.addEventListener('mouseenter', stop);
            reviewBox.addEventListener('focusin', stop);
          }
        }

        reviewBox.hidden = false;
      }

      // Cached per session so browsing between products doesn't refetch
      let cached = null;
      try {
        const raw = sessionStorage.getItem(cacheKey);
        const parsed = raw ? JSON.parse(raw) : null;
        if (parsed && Date.now() - parsed.t < cacheTtl) cached = parsed.r;
      } catch (e) {}

      if (cached) {
        render(cached);
      } else {
        const store = reviewBox.dataset.reviewStore;
        fetch('https://api.reviews.co.uk/timeline/data?store=' + encodeURIComponent(store)
          + '&sku=' + encodeURIComponent(reviewSku) + '&per_page=50')
          .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
          .then(function (data) {
            const reviews = pickReviews(data && data.timeline);
            try {
              sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), r: reviews }));
            } catch (e) {}
            render(reviews);
          })
          .catch(function () {});
      }
    }

    // ── Track which submit button was last clicked ────────────────
    // We resolve the selling_plan at submit time rather than relying on
    // the hidden input, so Seal Subscriptions or other scripts can't
    // clobber the value between click and submit.
    var pendingSellingPlan = null; // null = one-time, string = plan ID

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        pendingSellingPlan = null;
        activateOption('onetime', '');
      });
    }
    if (subscribeBtn) {
      subscribeBtn.addEventListener('click', function () {
        pendingSellingPlan = selectedPlanId();
        activateOption('subscribe', pendingSellingPlan);
      });
    }

    // ── Money formatter ───────────────────────────────
    function formatMoney(cents) {
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active : 'GBP';
      try {
        return (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: currency });
      } catch (e) {
        return '\u00a3' + (cents / 100).toFixed(2);
      }
    }

    // ── Add-to-cart → open cart drawer ────────────────────────────
    var form = root.querySelector('.product__form');
    if (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        var adding = form._adding;
        if (adding) return;
        form._adding = true;
        try {
          var formData = new FormData(form);
          // Explicitly set selling_plan from our tracked value, overriding
          // anything Seal Subscriptions or other scripts may have injected.
          if (pendingSellingPlan) {
            formData.set('selling_plan', pendingSellingPlan);
          } else {
            formData.delete('selling_plan');
          }
          // The frequency radios are a UI control, not a line item property
          Array.from(formData.keys()).forEach(function (key) {
            if (key.indexOf('plan-choice-') === 0) formData.delete(key);
          });
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: new URLSearchParams(formData)
          });
          if (res.ok) {
            // Prefer the drawer if it's available on the page
            if (typeof window.__cartDrawerOpen === 'function') {
              await window.__cartDrawerRefresh();
              window.__cartDrawerOpen();
            } else {
              // Fallback: navigate to cart
              window.location.href = '/cart';
            }
          } else {
            var err = await res.json().catch(function () { return {}; });
            console.error('[product] add to cart failed', err.description || err);
          }
        } catch (err) {
          console.error('[product] add to cart error', err);
        } finally {
          form._adding = false;
        }
      });
    }

    // ── Pairs-with card ──────────────────────────────────────────
    var pair = root.querySelector('[data-pair]');
    if (pair) {
      var pairAddBtn = pair.querySelector('[data-pair-add]');
      var pairOptions = pair.querySelectorAll('[data-pair-option]');
      var pairImg = pair.querySelector('[data-pair-img]');
      var pairTitle = pair.querySelector('[data-pair-title]');
      var pairVariantTitle = pair.querySelector('[data-pair-variant-title]');
      var pairPriceLabel = pair.querySelector('[data-pair-price-label]');
      var pairLinks = pair.querySelectorAll('[data-pair-link]');
      var pairVariantId = pair.dataset.pairVariant;
      var pairPrice = parseInt(pair.dataset.pairPrice, 10) || 0;

      // The main product's price follows the size pills; single-variant
      // products have none, so fall back to the price rendered server-side.
      function pairMainPrice() {
        var active = root.querySelector('.product__variant-btn--active');
        return active ? parseInt(active.dataset.variantPrice, 10) : parseInt(pair.dataset.mainPrice, 10);
      }

      function pairMainAvailable() {
        var active = root.querySelector('.product__variant-btn--active');
        return active ? active.dataset.variantAvailable !== 'false' : !pairAddBtn.hasAttribute('data-main-sold-out');
      }

      var pairSaving = pair.querySelector('[data-pair-saving]');
      var pairBadge = pair.querySelector('[data-pair-badge]');

      function parseJson(str) {
        try { return str ? JSON.parse(str) : null; } catch (e) { return null; }
      }

      // Bundle variant for the current selection: on a jar page it follows the
      // size pills via the map; on the spoon page it follows the strength pills.
      var pairBundle = parseJson(pair.dataset.pairBundle);
      var pairBundleMap = parseJson(pair.dataset.pairBundleMap) || {};
      var pairBundleFollowsMain = Object.keys(pairBundleMap).length > 0;

      function currentBundle() {
        if (pairBundleFollowsMain) {
          return (variantInput && pairBundleMap[variantInput.value]) || null;
        }
        return pairBundle;
      }

      function renderPairTotal() {
        if (!pairAddBtn) return;
        var main = pairMainPrice();
        var bundle = currentBundle();
        var full = main + pairPrice;
        var total = bundle ? bundle.price : full;
        var saving = full - total;
        var btnPrice = pairAddBtn.querySelector('[data-pair-btn-price]');
        var btnWas = pairAddBtn.querySelector('[data-pair-btn-was]');
        if (btnPrice) btnPrice.textContent = formatMoney(total);
        if (btnWas) {
          btnWas.textContent = formatMoney(full);
          btnWas.hidden = saving <= 0;
        }
        pairAddBtn.disabled = !pairMainAvailable();
        if (pairSaving) {
          pairSaving.hidden = saving <= 0;
          var text = pairSaving.querySelector('[data-pair-saving-text]');
          var deliveryMin = parseInt(pairSaving.dataset.deliveryMin, 10) || 0;
          var label = deliveryMin > 0 && total >= deliveryMin ? pairSaving.dataset.labelDelivery : pairSaving.dataset.label;
          if (text) text.textContent = label.replace('[amount]', formatMoney(saving));
        }
        if (pairBadge) {
          var pct = full > 0 ? Math.round(saving * 100 / full) : 0;
          pairBadge.hidden = pct <= 0;
          pairBadge.textContent = pairBadge.dataset.label.replace('[pct]', pct);
        }
      }

      pairOptions.forEach(function (btn) {
        btn.addEventListener('click', function () {
          pairOptions.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('product__pair-pill--active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          pairVariantId = btn.dataset.pairVariant;
          pairPrice = parseInt(btn.dataset.pairPrice, 10) || 0;
          pairBundle = parseJson(btn.dataset.pairBundle);
          if (pairTitle) pairTitle.textContent = btn.dataset.pairTitle;
          if (pairPriceLabel) pairPriceLabel.textContent = formatMoney(pairPrice);
          if (pairVariantTitle) {
            pairVariantTitle.textContent = btn.dataset.pairVariantTitle || '';
            pairVariantTitle.hidden = !btn.dataset.pairVariantTitle;
          }
          if (pairImg && btn.dataset.pairImg) {
            pairImg.src = btn.dataset.pairImg;
            pairImg.srcset = btn.dataset.pairImg + ' 1x, ' + btn.dataset.pairImgLarge + ' 2x';
          }
          pairLinks.forEach(function (a) { a.href = btn.dataset.pairUrl; });
          renderPairTotal();
        });
      });

      // Size pills update the main price after their own handler runs
      variantBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { requestAnimationFrame(renderPairTotal); });
      });

      if (pairAddBtn) {
        pairAddBtn.addEventListener('click', async function () {
          if (pairAddBtn._adding) return;
          pairAddBtn._adding = true;
          var label = pairAddBtn.innerHTML;
          pairAddBtn.textContent = pairAddBtn.dataset.labelAdding || pairAddBtn.textContent;
          pairAddBtn.disabled = true;
          try {
            var mainId = variantInput ? variantInput.value : null;
            var bundle = currentBundle();
            // One bundle line where a bundle exists, otherwise both products
            var items = bundle
              ? [{ id: bundle.id, quantity: 1 }]
              : [
                  { id: parseInt(mainId, 10), quantity: 1 },
                  { id: parseInt(pairVariantId, 10), quantity: 1 }
                ];
            var res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: items })
            });
            if (res.ok) {
              if (typeof window.__cartDrawerOpen === 'function') {
                await window.__cartDrawerRefresh();
                window.__cartDrawerOpen();
              } else {
                window.location.href = '/cart';
              }
            } else {
              var err = await res.json().catch(function () { return {}; });
              console.error('[product] add both failed', err.description || err);
            }
          } catch (err) {
            console.error('[product] add both error', err);
          } finally {
            pairAddBtn._adding = false;
            pairAddBtn.innerHTML = label;
            pairAddBtn.disabled = false;
          }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.stockists').forEach(function (section) {
      var track = section.querySelector('.stockists__track');
      var canonical = track && track.querySelector('.stockists__list');
      if (!track || !canonical) return;

      function setup() {
        /* Remove all previous clones, keeping only the canonical list */
        Array.from(track.querySelectorAll('.stockists__list')).forEach(function (list, i) {
          if (i > 0) list.remove();
        });

        var listWidth = canonical.offsetWidth;
        if (!listWidth) return;

        /*
         * We need enough copies so that at any scroll position the viewport
         * is always full. Strategy: fill 3× the viewport width ahead of the
         * starting position, then add 1 extra safety copy.
         */
        var copies = Math.ceil((window.innerWidth * 3) / listWidth) + 1;
        copies = Math.max(copies, 2);

        for (var i = 1; i < copies; i++) {
          var clone = canonical.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          /* Strip Shopify editor block attributes from clones */
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
            el.removeAttribute('data-shopify-editor-block');
          });
          track.appendChild(clone);
        }

        /*
         * Tell the keyframe animation the exact pixel distance to travel —
         * one canonical list width. This guarantees the reset from the end
         * back to the start is invisible (both positions look identical).
         */
        track.style.setProperty('--st-list-width', listWidth + 'px');

        /* Restart the animation cleanly */
        track.classList.remove('is-ready');
        track.style.animation = 'none';
        /* Force reflow so the browser registers the change */
        void track.offsetWidth;
        track.style.animation = '';
        track.classList.add('is-ready');
      }

      /* Wait for images to report their natural dimensions before measuring */
      var images = Array.from(canonical.querySelectorAll('img'));
      var pending = images.filter(function (img) { return !img.complete; });

      if (pending.length === 0) {
        requestAnimationFrame(function () { requestAnimationFrame(setup); });
      } else {
        var loaded = 0;
        pending.forEach(function (img) {
          function onLoad() {
            loaded++;
            if (loaded >= pending.length) {
              requestAnimationFrame(function () { requestAnimationFrame(setup); });
            }
          }
          img.addEventListener('load', onLoad, { once: true });
          img.addEventListener('error', onLoad, { once: true });
        });
      }

      /* Recalculate on viewport resize (debounced) */
      var resizeTimer;
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(setup, 150);
        }).observe(section);
      } else {
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(setup, 150);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initMarquee(strip) {
      var track = strip.querySelector('.story__track');
      if (!track) return;

      if (REDUCED_MOTION) {
        strip.style.overflowX = 'auto';
        return;
      }

      var speedValue = Math.max(1, Math.min(10, parseInt(strip.dataset.speed, 10) || 3));
      var pxPerSec = speedValue * 20;

      // Capture original slides before any cloning
      var origSlides = Array.prototype.slice.call(track.children);
      var origCount = origSlides.length;

      var pos = 0;
      var loopWidth = 0;
      var lastTs = null;
      var paused = false;

      function measure() {
        // Strip back to originals for a clean measurement
        while (track.children.length > origCount) {
          track.removeChild(track.lastChild);
        }
        // columnGap is the flex row gap — use parseFloat for sub-pixel accuracy
        var colGap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
        // loopWidth = distance from start of orig set[0] to start of clone set[0]
        // = scrollWidth(N items with N-1 gaps) + 1 more gap before first clone
        loopWidth = track.scrollWidth + colGap;
        // Fill until track extends at least one full loop past the strip edge,
        // guaranteeing no whitespace at any pos value in [0, loopWidth)
        var minWidth = loopWidth + strip.offsetWidth;
        while (track.scrollWidth < minWidth) {
          for (var j = 0; j < origCount; j++) {
            var clone = origSlides[j].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
          }
        }
      }

      function tick(ts) {
        if (!paused && lastTs !== null) {
          var dt = Math.min((ts - lastTs) / 1000, 0.1);
          pos += pxPerSec * dt;
          if (loopWidth > 0 && pos >= loopWidth) pos -= loopWidth;
          track.style.transform = 'translateX(-' + pos + 'px)';
        }
        lastTs = ts;
        requestAnimationFrame(tick);
      }

      strip.addEventListener('mouseenter', function () { paused = true; });
      strip.addEventListener('mouseleave', function () { paused = false; lastTs = null; });

      measure();
      window.addEventListener('resize', function () {
        measure();
        if (loopWidth > 0 && pos >= loopWidth) pos = pos % loopWidth;
      });

      requestAnimationFrame(tick);
    }

    function init() {
      var strips = document.querySelectorAll('.story__strip');
      for (var i = 0; i < strips.length; i++) {
        initMarquee(strips[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
